module.exports = __webpack_public_path__ + "static/media/BwModelicaSS02-Medium.0331fd9e.otf";